import React, { useState, useEffect, useContext } from "react";
// import { DataTable } from "primereact/datatable";
// import Loading from "../../components/Loading";
import Loading from "../components/Loading.jsx";
import DataTable from "react-data-table-component";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { TfiMenuAlt } from "react-icons/tfi";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../context/DealerProfile.jsx";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import useSWR, { mutate } from "swr";
import { useMemo } from "react";
import { Bell, Cake, X, PhoneCall } from 'lucide-react'
import { useLocation } from "react-router-dom";
// import { Pagination } from "flowbite-react";
import { AllStates } from "../context/globalState.jsx";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const getPageNumbers = () => {
        const pages = [];
        const maxPagesToShow = 5;

        if (totalPages <= maxPagesToShow + 2) {
            // Show all pages if total is small
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            const left = Math.max(2, currentPage - 1);
            const right = Math.min(totalPages - 1, currentPage + 1);

            pages.push(1); // First page

            if (left > 2) pages.push('...'); // Left ellipsis

            for (let i = left; i <= right; i++) pages.push(i); // Middle pages

            if (right < totalPages - 1) pages.push('...'); // Right ellipsis

            pages.push(totalPages); // Last page
        }

        return pages;
    };

    const pages = getPageNumbers();

    return (
        <div className="flex flex-wrap justify-center items-center gap-2 mt-4 mr-[45px]">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Previous
            </button>

            {pages.map((page, index) =>
                page === '...' ? (
                    <span key={index} className="px-3 py-1 text-gray-500">
                        {page}
                    </span>
                ) : (
                    <button
                        key={index}
                        onClick={() => onPageChange(page)}
                        className={`px-3 py-1 rounded hover:bg-gray-300 ${page === currentPage
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-200'
                            }`}
                    >
                        {page}
                    </button>
                )
            )}

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Next
            </button>
        </div>
    );
};



export default function ContactsTable() {
    const { dealerDetail } = useUserContext();
    const { allState, allStatedispatch } = useContext(AllStates);
    const [error, setError] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const navigate = useNavigate();
    // const [isLoading, setIsLoading] = useState(true);
    // const [leads, setLeads] = useState([]);
    const [lead, setLead] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [alternatePhoneError, setAlternatePhoneError] = useState("");


    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);


    const [openDropdown, setOpenDropdown] = useState(null);  // Track open dropdown
    const [formData, setFormData] = useState({}); // Store lead form data
    const [editingId, setEditingId] = useState(null);
    const [widgetValues, setWidgetValues] = useState({}); // Store widget values
    const [isWidgetModalOpen, setIsWidgetModalOpen] = useState(false);
    const [alternatePhone, setAlternatePhone] = useState(lead?.Phone_2 || "");
    const [callRemarks, setCallRemarks] = useState("");
    const [donorInterest, setDonorInterest] = useState("");
    const [callStatus, setCallStatus] = useState("");
    const [donorName, setDonorName] = useState("");
    const [email, setEmail] = useState(lead?.Email || "");
    const [phone, setPhone] = useState(lead?.Mobile_No || "");
    const [rescheduleDateTime, setRescheduleDateTime] = useState("");
    const [contactPreference, setContactPreference] = useState("Call");

    // When initializing
    const [searchValues, setSearchValues] = useState(() => {
        const saved = JSON.parse(localStorage.getItem("Contactspagination")) || {};
        return {
            limit: saved.limit || 25,
            page: saved.page || 1,
        };
    });

    // When updating
    useEffect(() => {
        localStorage.setItem("Contactspagination", JSON.stringify(searchValues));
    }, [searchValues]);



    const [selectedRow, setSelectedRow] = useState(null); // Optional

    const [donationOptions, setDonationOptions] = useState([]);
    const [contactPreferencesOptions, setContactPreferencesOptions] = useState([]);
    const [callDispositionOptions, setCallDispositionOptions] = useState([]);
    const [selectedCallDisposition, setSelectedCallDisposition] = useState("Not Started");

    const [leadSourceOptions, setLeadSourceOptions] = useState([]);

    // const [callRemarks, setCallRemarks] = useState("");


    // -------- all state function 
    const allStateFunction = async (key, url) => {
        if (allState[key]) {
            return allState[key]
        }
        else {
            const res = await fetch(url);
            const result = await res.json();
            if (!result || !result?.status || result?.status != "success") {
                return null
            }
            allStatedispatch({
                type: "add",
                payload: { [key]: result?.data },
            })
            return result?.data
        }
    }

    const fetchPicklistOptions = async (fieldId, setOptions) => {
        try {
            const res = await fetch(
                `/server/dealer_backend/getPickListValues/${fieldId}?module=Contacts&type=used`
            );
            const result = await res.json();
            if (result.status === "success") {
                // console.log({ fieldId, result });
                setOptions(result.data || []);
                const key = `picklist-${fieldId}`
                allStatedispatch({
                    type: "add",
                    payload: { [key]: result?.data },
                })

            } else {
                console.error("Failed to fetch picklist:", result.error);
            }
        } catch (err) {
            console.error("Error fetching picklist:", err);
        }
    };

    useEffect(() => {

        const picklistMap = [
            { key: 'picklist-760958000001085586', action: () => fetchPicklistOptions("760958000001085586", setDonationOptions), onData: setDonationOptions },
            { key: 'picklist-760958000004566661', action: () => fetchPicklistOptions("760958000004566661", setContactPreferencesOptions), onData: setContactPreferencesOptions },
            { key: 'picklist-760958000004425144', action: () => fetchPicklistOptions("760958000004425144", setCallDispositionOptions), onData: setCallDispositionOptions },
        ]

        // if(!allState['picklist-760958000001085586']){
        //     fetchPicklistOptions("760958000001085586", setDonationOptions);        // Donation Purpose
        // }else{
        //     setDonationOptions(allState['picklist-760958000001085586'])
        // }
        // if(!allState['picklist-760958000004566661']){
        //     fetchPicklistOptions("760958000004566661", setContactPreferencesOptions); // Contact Preferences
        // }
        // if(!allState['picklist-760958000004425144']){
        //     fetchPicklistOptions("760958000004425144", setCallDispositionOptions);   // Call Dispositions
        // }

        picklistMap.forEach(ob => {
            if (!allState[ob?.key]) {
                // console.log("fetching : ", ob.key)
                ob.action();
            } else {
                ob.onData(allState[ob?.key]);
            }
        })

        // console.log("---- PICKLIST ----")
        // console.log(allState['picklist-760958000001085586'])
        // console.log(allState['picklist-760958000004566661'])
        // console.log(allState['picklist-760958000004425144'])
        // console.log(allState)
        // fetchPicklistOptions("760958000000407488", setLeadSourceOptions); // IFR Lead Source
    }, []);

    // const [totalRecords, setTotalRecords] = useState(0);
    const [filteredLead, setFilteredLead] = useState([]);


    const columns = [

        {
            // Flag column — no wrapping needed, keep as is:
            selector: row =>
                row.Contact_Preferences === "Do Not Disturb" ? (
                    <span
                        style={{
                            color: "red",
                            marginRight: 8,
                            fontSize: 18,
                        }}
                        title="Do Not Disturb"
                    >
                        🚩
                    </span>
                ) : null,
            width: "70px",
            ignoreRowClick: true,
            style: { textAlign: "center" },
        },

        {
            name: "S.No",
            selector: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
            sortable: false,
            width: "80px",
            center: true,
        },

        {
            name: "List Name",
            selector: row => row.Campaign_Name ?? "",
            cell: (row, index) => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                        whiteSpace: "normal", // ✅ allow wrapping
                        wordBreak: "break-word",
                        display: "block",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => {
                        saveLastOpened(row, (currentPage - 1) * rowsPerPage + index + 1);
                        window.open(`/app/contact-details/${row.id}`, "_blank");
                    }}
                >
                    {row.Campaign_Name ?? ""}
                </span>
            ),

            sortable: true,
            wrap: true,
            style: {
                fontSize: 16,
                color: "#5A5A5C",
                whiteSpace: "normal",
                wordBreak: "break-word",
            },
            minWidth: "200px",
        },

        {
            name: "Existing Donor Name",
            selector: row => `${row.First_Name ?? ""} ${row.Last_Name ?? ""}`,
            cell: (row, index) => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        display: "block",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => {
                        saveLastOpened(row, (currentPage - 1) * rowsPerPage + index + 1);
                        window.open(`/app/contact-details/${row.id}`, "_blank");
                    }}

                >
                    {`${row.First_Name ?? ""} ${row.Last_Name ?? ""}`}
                </span>
            ),
            sortable: true,
            wrap: true,
            style: {
                fontSize: 16,
                color: "#5A5A5C",
                whiteSpace: "normal",
                wordBreak: "break-word",
            },
            minWidth: "200px",
        },

        // {
        //     name: "Last Donation Amount",
        //     selector: row =>
        //         typeof row.Last_Donation_Amount === "number"
        //             ? row.Last_Donation_Amount
        //             : parseFloat(row.Last_Donation_Amount) || 0,
        //     cell: (row, index) => (
        //         <span
        //             style={{
        //                 fontSize: 16,
        //                 cursor: "pointer",
        //                 color: "#5A5A5C",
        //                 transition: "color 0.2s ease-in-out",
        //                 whiteSpace: "normal",
        //                 wordBreak: "break-word",
        //                 display: "block",
        //             }}
        //             onMouseEnter={e => (e.target.style.color = "blue")}
        //             onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
        //             onClick={() => {
        //                 saveLastOpened(row, (currentPage - 1) * rowsPerPage + index + 1);
        //                 window.open(`/app/contact-details/${row.id}`, "_blank");
        //             }}

        //         >
        //             {row.Last_Donation_Amount ?? ""}
        //         </span>
        //     ),
        //     sortable: true,
        //     wrap: true,
        //     style: {
        //         fontSize: 16,
        //         color: "#5A5A5C",
        //         whiteSpace: "normal",
        //         wordBreak: "break-word",
        //     },
        //     minWidth: "200px",
        // },

        {
            name: "Last Donation Status",
            selector: row => row.Last_Donation_Status ?? "",
            cell: (row, index) => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        display: "block",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => {
                        saveLastOpened(row, (currentPage - 1) * rowsPerPage + index + 1);
                        window.open(`/app/contact-details/${row.id}`, "_blank");
                    }}

                >
                    {row.Last_Donation_Status ?? ""}
                </span>
            ),
            sortable: true,
            wrap: true,
            style: {
                fontSize: 16,
                color: "#5A5A5C",
                whiteSpace: "normal",
                wordBreak: "break-word",
            },
            minWidth: "200px",
        },

        {
            name: "Last Donation Date",
            selector: (row, index) => {
                const date = new Date(row.Last_Donation_Date);
                return isNaN(date) ? 0 : date.getTime();
            },
            cell: row => {
                const date = new Date(row.Last_Donation_Date);
                return (
                    <span
                        style={{
                            fontSize: 16,
                            color: "#5A5A5C",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            display: "block",
                        }}
                    >
                        {isNaN(date) ? "" : date.toLocaleDateString()}
                    </span>
                );
            },
            sortable: true,
            wrap: true,
            style: {
                fontSize: 16,
                color: "#5A5A5C",
                whiteSpace: "normal",
                wordBreak: "break-word",
            },
            minWidth: "200px",
        },

        {
            name: "Purpose",
            selector: row => row.Purpose1 ?? "",
            cell: (row, index) => (
                <span
                    style={{
                        fontSize: 16,
                        cursor: "pointer",
                        color: "#5A5A5C",
                        transition: "color 0.2s ease-in-out",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        display: "block",
                    }}
                    onMouseEnter={e => (e.target.style.color = "blue")}
                    onMouseLeave={e => (e.target.style.color = "#5A5A5C")}
                    onClick={() => {
                        saveLastOpened(row, (currentPage - 1) * rowsPerPage + index + 1);
                        window.open(`/app/contact-details/${row.id}`, "_blank");
                    }}

                >
                    {row.Purpose1 ?? ""}
                </span>
            ),
            sortable: true,
            wrap: true,
            style: {
                fontSize: 16,
                color: "#5A5A5C",
                whiteSpace: "normal",
                wordBreak: "break-word",
            },
            minWidth: "200px",
        },

        {
            name: "Action",
            cell: (row, index) => (
                <button
                    onClick={e => {
                        e.stopPropagation();

                        // Update lastOpened in localStorage and state
                        const serialNo = (currentPage - 1) * rowsPerPage + index + 1;
                        const record = {
                            id: row.id,
                            name: `${row.First_Name ?? ""} ${row.Last_Name ?? ""}`,
                            listName: row.Campaign_Name ?? "",
                            disposition: row.Call_Status ?? "",
                            lastOpenedAt: new Date().toISOString(), // Store date of last opening
                            serialNo,
                        };
                        localStorage.setItem("lastOpenedRecord", JSON.stringify(record));
                        setLastOpened(record); // Update state so UI updates immediately

                        // Open modal and set other state
                        setSelectedRow(row);
                        setLead(row);
                        setEmail(row.Email || "");
                        setPhone(row.Mobile_No || "");
                        setAlternatePhone(row.Phone_2 || "");
                        setCallRemarks("");
                        setDonationPurpose(row.Purpose1 || "");
                        setContactPreference(row.Contact_Preferences || "");
                        setCallStatus(row.Call_Status || "");
                        setIsWidgetModalOpen(true);
                    }}
                    className="log-button"
                >
                    <PhoneCall />
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            style: { fontSize: 16 },
        }

    ];


    const [donationPurpose, setDonationPurpose] = useState("");


    // const [catalystUsers, setCatalystUsers] = useState([]);

    // useEffect(() => {
    //     const fetchCatalystUsers = async () => {
    //         if (allState["CatalystUser"]) {
    //             setCatalystUsers(allState["CatalystUser"]);
    //             // console.log("skip fetch catalyst user")
    //             return
    //         }
    //         try {
    //             const response = await fetch("/server/dealer_backend/getCatalystUsers");
    //             const data = await response.json();
    //             // console.log(data)
    //             if (data.status === "success") {
    //                 setCatalystUsers(data.data);
    //                 allStatedispatch({
    //                     type: "add",
    //                     payload: { "CatalystUser": data.data },
    //                 })
    //             } else {
    //                 // console.error("Failed to fetch Catalyst Users:", data.error);
    //             }
    //         } catch (error) {
    //             // console.error("Error fetching Catalyst Users:", error);
    //         }
    //     };

    //     fetchCatalystUsers();
    // }, []);

    // const [error, setError] = useState(false);

    const [remarksError, setRemarksError] = useState("");

    const handleSubmit = async () => {
        let isValid = true;
        setEmailError("");
        setPhoneError("");
        setAlternatePhoneError("");
        setError(false); // 👈 Make sure this exists in your state
        setIsSubmitting(true);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[0-9]{10}$/;

        if (email && !emailRegex.test(email)) {
            const msg = "Please enter a valid email address.";
            setEmailError(msg);
            toast.error(msg);
            isValid = false;
        }

        if (phone && !phoneRegex.test(phone)) {
            const msg = "Phone must be a 10-digit number.";
            setPhoneError(msg);
            toast.error(msg);
            isValid = false;
        }

        // if (alternatePhone && !phoneRegex.test(alternatePhone)) {
        //     const msg = "Alternate phone must be a 10-digit number.";
        //     setAlternatePhoneError(msg);
        //     toast.error(msg);
        //     isValid = false;
        // }

        // if (!contactPreference) {
        //     toast.error("Please select a Contact Preference.");
        //     setError(true); // 👈 this helps trigger error message in JSX
        //     isValid = false;
        // }

        if (!donationPurpose) {
            toast.error("Please select Donor Interest.");
            setError(true); // 👈 this helps trigger error message in JSX
            isValid = false;
        }

        if (!callStatus) {
            toast.error("Please select a Call Disposition.");
            setError(true); // 👈 this helps trigger error message in JSX
            isValid = false;
        }

        if (callStatus === "Call back" && !rescheduleDateTime) {
            toast.error("Please select a reschedule date and time.");
            isValid = false;
        }

        if (callStatus === "Hot lead" && !rescheduleDateTime) {
            toast.error("Please select a reschedule date and time.");
            isValid = false;
        }

        if (!callRemarks || callRemarks.trim() === "") {
            const msg = "Remarks are required.";
            setRemarksError(msg);
            isValid = false;
        }

        if (!isValid) {
            setIsSubmitting(false);
            return;
        }

        // 🚀 Continue with form submission logic...
        // ✅ 3. Update Contact Preference in Contacts Module
        try {
            const contactUpdatePayload = {
                data: [
                    {
                        Contact_Preferences: contactPreference,
                        Phone_2: alternatePhone,
                        Remarks: callRemarks,
                        // Purpose1: donationPurpose, // ✅ use donationPurpose here
                        Mobile_No: phone,
                        Call_Status: callStatus // ✅ Add this
                    },
                ],
            };

            const contactUpdateRes = await fetch(`/server/dealer_backend/edit-contactDetails/${lead?.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(contactUpdatePayload),
            });

            const contactUpdateResult = await contactUpdateRes.json();

            if (contactUpdateResult.status !== "success") {
                // console.error("Failed to update contact preference:", contactUpdateResult.error);
                toast.error("Failed to update contact preference.");
            }
        } catch (err) {
            // console.error("Error updating contact preference:", err);
            toast.error("An error occurred while updating contact details.");
        }

        // ✅ 4. Submit Call Log to Calls Module


       // ✅ 4. Submit Call Log to Calls Module

const callPayload = {
    data: [
        {
            Related_Record_of_Donor: {
                id: lead?.id,
                name: `${lead?.First_Name || ""} ${lead?.Last_Name || ""}`.trim(),
            },

            Name: `${lead?.First_Name || ""} ${lead?.Last_Name || ""}`.trim(),

            Email: lead?.Email || email,

            Mobile_Number: lead?.Mobile || phone,

            Alternate_Mobile: alternatePhone,

            Remarks: callRemarks,

            Purpose1: donationPurpose,

            Call_Status: callStatus,

            Call_Type: "outbound",

            Reschedule_Time:
                (callStatus === "Call back" || callStatus === "Hot lead") &&
                rescheduleDateTime
                    ? formatDateForBackend(rescheduleDateTime)
                    : null,

            Catalyst_User: lead?.Catalyst_User
                ? lead?.Catalyst_User?.id
                : null,

            Catalyst_User_Email: lead?.Catalyst_User_Email || "",
        },
    ],
};

// try {
//     const callRes = await fetch(
//         "/server/dealer_backend/handleCalls",
//         {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify(callPayload),
//         }
//     );

//     const callResult = await callRes.json();

//     if (!callRes.ok || callResult.status !== "success") {
//         toast.error("Failed to create call log.");
//         return;
//     }

//     // ==========================================
//     // ✅ 5. Trigger Acefone Click-to-Call
//     // ==========================================

//     try {
//         const acefoneRes = await fetch(
//             "/server/dealer_backend/clickToCall",
//             {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify({
//                     destination_number: lead?.Mobile || phone,

//                     // Replace this with the actual agent number
//                     // associated with the logged-in user.
//                     agent_number: dealerDetail?.Agent_Phone_No,
//                 }),
//             }
//         );

//         const acefoneResult = await acefoneRes.json();

//         if (!acefoneRes.ok || acefoneResult.status !== "success") {
//             console.error("Acefone click-to-call failed:", acefoneResult);

//             toast.error("Call log created, but call could not be initiated.");

//             return;
//         }

//         console.log("Acefone call initiated:", acefoneResult);

//         toast.success("Call initiated successfully!");

//     } catch (acefoneError) {
//         console.error(
//             "Error initiating Acefone call:",
//             acefoneError
//         );

//         toast.error(
//             "Call log created, but there was an error initiating the call."
//         );

//         return;
//     }

//     // 🔄 SWR revalidation
//     await refresh();

//     return true;

// } catch (error) {
//     console.error("Error submitting call log:", error);

//     toast.error("An unexpected error occurred.");
// }

        try {
            const callRes = await fetch("/server/dealer_backend/handleCalls", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(callPayload),
            });

            const callResult = await callRes.json();

            if (!callRes.ok || callResult.status !== "success") {
                // console.error("Call creation failed:", callResult);
                toast.error("Failed to create call log.");
                return;
            }

            toast.success("Call log created successfully!");
            // await fetchContacts({}, true);
            // 🔄 SWR revalidation
            await refresh();
            return true;
        } catch (error) {
            // console.error("Error submitting call log:", error);
            toast.error("An unexpected error occurred.");
        }
    };



    useEffect(() => {
        if (isWidgetModalOpen) {
            // Reset all form fields when modal opens
            setEmail(lead?.Email || "");
            setPhone(lead?.Mobile_No || "");
            setAlternatePhone(lead?.Phone_2 || "");
            setCallRemarks("");
            setDonationPurpose(lead?.Purpose1 || "");
            setCallStatus(lead.Call_Status || "");
            setRescheduleDateTime("");
            setEmailError("");
            setPhoneError("");
            setAlternatePhoneError("");
            setError(false);
            setIsSubmitting(false);
        }
    }, [isWidgetModalOpen, lead]);

    // const currentPage = page || 1;
    //    const currentPage = page || 1;
    const pageSize = limit || 20;




    const formatDateForBackend = (dateInput) => {
        if (!dateInput) return "";

        const date = new Date(dateInput);

        const pad = (n) => n.toString().padStart(2, "0");

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        const offset = -date.getTimezoneOffset(); // Note the sign flip
        const sign = offset >= 0 ? "+" : "-";
        const absOffset = Math.abs(offset);
        const offsetHours = pad(Math.floor(absOffset / 60));
        const offsetMinutes = pad(absOffset % 60);

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
    };

    const markBirthdayAsSeen = (leadId) => {
        let seen = JSON.parse(localStorage.getItem('seenBirthdayLeads') || "[]");
        if (!seen.includes(leadId)) {
            seen.push(leadId);
            localStorage.setItem('seenBirthdayLeads', JSON.stringify(seen));

            // Optimistically update the birthday leads in the SWR cache
            const listName = Array.isArray(dealerDetail?.List_Name)
    ? dealerDetail.List_Name
    : dealerDetail?.List_Name?.listName || [];

const key = dealerDetail?.Email
    ? `/server/dealer_backend/getBirthdays?dealerEmail=${encodeURIComponent(dealerDetail.Email)}&listName=${encodeURIComponent(JSON.stringify([...listName].sort()))}`
    : null;
            mutate(key, (currentData) => {
                if (!currentData) return currentData;
                return currentData.filter(lead => lead.id !== leadId);
            }, false);
            // `false` means do not revalidate after update
        }
    };



    // 1. Fetch and set contacts
    // const fetchContacts = async (filters = {}, forceRefresh = false) => {
    //     setIsLoading(true);

    //     const {
    //         disposition = selectedDisposition,
    //         campaignName = selectedCampaignName,
    //         email = emailFilter,
    //         phone = phoneFilter,
    //         donor = donorNameFilter
    //     } = filters;

    //     // Determine if any filter is applied
    //     const hasFilters =
    //         (disposition && disposition !== '') ||
    //         (campaignName && campaignName !== '-None-') ||
    //         (email && email.trim() !== '') ||
    //         (phone && phone.trim() !== '') ||
    //         (donor && donor.trim() !== '');

    //     let t = '';
    //     [disposition, campaignName, email, phone, donor].forEach(f => {
    //         t = `${f}-${t}`;
    //     });

    //     const key = `donor-contacts-${searchValues.page}-${searchValues.limit}-${t}${dealerDetail?.Email}`;

    //     // Skip cache if forceRefresh is true OR filters are applied
    //     if (!forceRefresh && !hasFilters && allState[key]) {
    //         setLeads(allState[key]?.data);
    //         setTotalRecords(allState[key]?.total);
    //         setIsLoading(false);
    //         return;
    //     }

    //     try {
    //         const res = await fetch("/server/dealer_backend/getContactsPaginated", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({
    //                 page: searchValues.page,
    //                 limit: searchValues.limit,
    //                 dealerEmail: dealerDetail?.Email,
    //                 selectedDisposition: disposition,
    //                 selectedCampaignName: campaignName,
    //                 emailFilter: email,
    //                 phoneFilter: phone,
    //                 donorNameFilter: donor
    //             }),
    //         });

    //         const data = await res.json();
    //         if (data.status === "success") {
    //             let allLeads = (data.data || []).sort(
    //                 (a, b) => new Date(b.Created_Time) - new Date(a.Created_Time)
    //             );
    //             allStatedispatch({
    //                 type: "add",
    //                 payload: { [key]: { data: allLeads, total: data.pagination.totalRecords } }
    //             });
    //             setLeads(allLeads);
    //             setTotalRecords(data.pagination.totalRecords);
    //         } else {
    //             setLeads([]);
    //             setTotalRecords(0);
    //         }
    //     } catch (error) {
    //         // console.error("Error fetching contacts:", error);
    //         setLeads([]);
    //         setTotalRecords(0);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };


    // custom fetcher for POST




    const location = useLocation();

    // ----------------------
    // Load filters from localStorage when component mounts
    // ----------------------
    const [selectedDisposition, setSelectedDisposition] = useState(() =>
        localStorage.getItem("disposition") || "Not Started"
    );
    const [selectedCampaignName, setSelectedCampaignName] = useState(() =>
        localStorage.getItem("campaign") || ""
    );
    const [emailFilter, setEmailFilter] = useState(() =>
        localStorage.getItem("email") || ""
    );
    const [phoneFilter, setPhoneFilter] = useState(() =>
        localStorage.getItem("phone") || ""
    );
    const [donorNameFilter, setDonorNameFilter] = useState(() =>
        localStorage.getItem("donor") || ""
    );

    // ----------------------
    // Applied filters (merged into a single state object)
    // ----------------------


    // ✅ "Applied" filters — what actually gets sent to API
    const [appliedFilters, setAppliedFilters] = useState({
        selectedDisposition,
        selectedCampaignName,
        emailFilter,
        phoneFilter,
        donorNameFilter
    });


    // ----------------------
    // Sync → localStorage whenever filters change
    // ----------------------
    useEffect(() => {
        localStorage.setItem("disposition", selectedDisposition);
        localStorage.setItem("campaign", selectedCampaignName);
        localStorage.setItem("email", emailFilter);
        localStorage.setItem("phone", phoneFilter);
        localStorage.setItem("donor", donorNameFilter);

        // also update appliedFilters in sync

    }, [selectedDisposition, selectedCampaignName, emailFilter, phoneFilter, donorNameFilter]);

    // ----------------------
    // Fetcher utility
    // ----------------------
    const postFetcher = (url, body) =>
        fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        }).then((res) => {
            if (!res.ok) throw new Error("Failed to fetch");
            return res.json();
        });

    function useLeads(params) {
        const key = params ? ["/server/dealer_backend/getContactsPaginated", params] : null;

        const { data, error, isLoading } = useSWR(
            key,
            ([url, body]) => postFetcher(url, body),
            {
                revalidateOnFocus: false,
                keepPreviousData: true,
            }
        );



        // filter leads by layout.id
        const filteredLeads = data?.data.filter(
            lead => lead?.Layout?.id === '760958000000403509'
        );




        return {
            leads: filteredLeads || [],
            pagination: data?.pagination || {},
            isLoading,
            totalRecords: data?.pagination?.totalRecords || 0,
            isError: error,
            refresh: () => mutate(key),
        };
    }

    const leadParams = useMemo(() => ({
        page: searchValues.page,
        limit: searchValues.limit,
        dealerEmail: dealerDetail?.Email,
        listName: dealerDetail?.List_Name,
        ...appliedFilters,
    }), [searchValues.page, searchValues.limit, dealerDetail?.Email, appliedFilters]);


    // ✅ Hook fetches with appliedFilters
    const { leads, pagination, totalRecords, isLoading, isError, refresh } = useLeads(leadParams);





    // 2. Fetch and set birthdays
    // const fetchBirthdayLeads = async () => {
    //     try {
    //         const birthdayRes = await fetch("/server/dealer_backend/getBirthdays", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({ dealerEmail: dealerDetail?.Email }),
    //         });

    //         const birthdayData = await birthdayRes.json();

    //         if (birthdayData.status === "success") {
    //             const seen = JSON.parse(localStorage.getItem("seenBirthdayLeads") || "[]");

    //             const today = new Date();
    //             today.setHours(0, 0, 0, 0);

    //             const tomorrow = new Date(today);
    //             tomorrow.setDate(today.getDate() + 1);

    //             const filtered = (birthdayData.data || []).map((lead) => {
    //                 const dob = new Date(lead.Date_of_Birth);
    //                 const thisYearBirthday = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());
    //                 thisYearBirthday.setHours(0, 0, 0, 0);

    //                 let daysUntilBirthday = null;
    //                 if (thisYearBirthday.getTime() === today.getTime()) {
    //                     daysUntilBirthday = 0;
    //                 } else if (thisYearBirthday.getTime() === tomorrow.getTime()) {
    //                     daysUntilBirthday = 1;
    //                 }

    //                 return { ...lead, daysUntilBirthday };
    //             }).filter(lead =>
    //                 (lead.daysUntilBirthday === 0 || lead.daysUntilBirthday === 1) &&
    //                 !seen.includes(lead.id)
    //             );

    //             setBirthdayLeads(filtered);
    //         } else {
    //             setBirthdayLeads([]);
    //         }
    //     } catch (error) {
    //         console.error("Error fetching birthday leads:", error);
    //         setBirthdayLeads([]);
    //     }
    // };



    // useEffect(() => {
    //     fetchContacts();
    // }, [searchValues.page, searchValues.limit, dealerDetail?.Email]);




    const fetchBirthdayLeadsFetcher = async (url, body) => {
        const res = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });

        if (!res.ok) throw new Error("Failed to fetch birthday leads");

        const birthdayData = await res.json();

        if (birthdayData.status !== "success") return [];

        const seen = JSON.parse(localStorage.getItem("seenBirthdayLeads") || "[]");

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const leadsWithBirthdayInfo = (birthdayData.data || []).map((lead) => {
            const dob = new Date(lead.Date_of_Birth);
            const thisYearBirthday = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());
            thisYearBirthday.setHours(0, 0, 0, 0);

            let daysUntilBirthday = null;
            if (thisYearBirthday.getTime() === today.getTime()) {
                daysUntilBirthday = 0;
            } else if (thisYearBirthday.getTime() === tomorrow.getTime()) {
                daysUntilBirthday = 1;
            }

            return { ...lead, daysUntilBirthday };
        }).filter(lead =>
            (lead.daysUntilBirthday === 0 || lead.daysUntilBirthday === 1) &&
            !seen.includes(lead.id)
        );

        // 🔽 Sort: today (0) first, then tomorrow (1)
        leadsWithBirthdayInfo.sort((a, b) => a.daysUntilBirthday - b.daysUntilBirthday);

        return leadsWithBirthdayInfo;
    };



    const listName = Array.isArray(dealerDetail?.List_Name)
    ? dealerDetail.List_Name
    : dealerDetail?.List_Name?.listName || [];

const key = dealerDetail?.Email
    ? `/server/dealer_backend/getBirthdays?dealerEmail=${encodeURIComponent(dealerDetail.Email)}&listName=${encodeURIComponent(JSON.stringify([...listName].sort()))}`
    : null;

    const { data: birthdayLeads } = useSWR(
        key,
        fetchBirthdayLeadsFetcher,
        {
            revalidateOnFocus: false,     // ❌ don’t refetch on tab focus
            revalidateOnReconnect: false, // ❌ don’t refetch on network reconnect
            revalidateIfStale: false,     // ❌ don’t refetch even if stale
            shouldRetryOnError: false     // optional: don’t retry endlessly
        }
    );













    // console.log({ leads })







    // Your filter change handlers
    const onDispositionChange = (e) => {
        setSelectedDisposition(e.target.value);
        setCurrentPage(1);
    };

    const onCampaignChange = (e) => {
        setSelectedCampaignName(e.target.value);
        setCurrentPage(1);
    };



    const onPageChange = (newPage) => {
        setCurrentPage(newPage);
        setSearchValues((prev) => ({
            ...prev,
            page: newPage
        }));
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1);
    };
    const [showBirthdayDropdown, setShowBirthdayDropdown] = useState(false);
    // const [birthdayLeads, setBirthdayLeads] = useState([]);

    const getDaysUntilBirthday = (dobStr) => {
        if (!dobStr) return null;

        const today = new Date();
        const dob = new Date(dobStr);
        const nextBirthday = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

        // If the birthday this year already passed, go to next year
        if (
            nextBirthday.getMonth() === today.getMonth() &&
            nextBirthday.getDate() === today.getDate()
        ) {
            return 0; // 🎂 TODAY!
        }

        if (nextBirthday < today) {
            nextBirthday.setFullYear(today.getFullYear() + 1);
        }

        const diffTime = nextBirthday - today;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };

    function useIsMobile(breakpoint = 768) {
        const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

        useEffect(() => {
            const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, [breakpoint]);

        return isMobile;
    }

    function MobileDonorCard({
        donor,
        serialNo, // New prop for serial number
        setLead,
        setPhone,
        setEmail,
        setAlternatePhone,
        setCallRemarks,
        setDonationPurpose,
        setCallStatus,
        setIsWidgetModalOpen,
    }) {
        const handleCreateLog = (e) => {
            e.preventDefault();
            e.stopPropagation();

            setLead(donor);
            setPhone(donor.Phone);
            setEmail(donor.Email || "");
            setAlternatePhone(donor.Alternate_Mobile || "");
            setCallRemarks("");
            setDonationPurpose(donor?.Purpose1);
            setCallStatus(donor?.Call_Status);
            setIsWidgetModalOpen(true);
        };

        return (
            <Link to={`/contact-details/${donor.id}`}>
                <div
                    className="mobile-card ml-[-24px]
          bg-white 
          shadow 
          rounded-xl 
          p-4 
          mb-4 
          w-[121%] 
          max-w-md 
          hover:bg-gray-50 
          transition 
          cursor-pointer
        "
                >
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-2">
                        {/* Left side */}
                        <div className="flex items-center gap-3">
                            <div
                                className="
                w-10 
                h-10 
                rounded-full 
                bg-blue-100 
                flex 
                items-center 
                justify-center 
                text-blue-600 
                font-bold 
                text-lg
              "
                            >
                                {serialNo || "1"} {/* Display serial number */}
                            </div>
                            <div>
                                <p className="font-semibold text-gray-900">
                                    {`${donor.First_Name || ""} ${donor.Last_Name || ""}`.trim()}
                                </p>
                                <p className="text-xs text-gray-500">{donor.id}</p>
                            </div>
                        </div>

                        {/* Right side */}
                        <div className="flex flex-col items-start sm:items-end gap-2">
                            <span
                                className="
                text-xs 
                bg-green-100 
                text-green-700 
                px-3 
                py-1 
                rounded-full 
                font-semibold
                whitespace-nowrap
              "
                            >
                                {donor.IFR_Lead_Sources || ""}
                            </span>
                            <button
                                onClick={handleCreateLog}
                                className="
                bg-blue-600 
                text-white 
                text-xs 
                px-3 
                py-1 
                rounded 
                hover:bg-blue-700 
                transition
              "
                            >
                                Create Log
                            </button>
                        </div>
                    </div>

                    <hr className="my-2" />

                    <div className="text-sm text-gray-700 space-y-1">
                        <div className="flex justify-between">
                            <span className="text-gray-500">List Name</span>
                            <span className="text-right">{donor.Campaign_Name || "N/A"}</span>
                        </div>
                        {/* <div className="flex justify-between">
                            <span className="text-gray-500">Last Donation Amount</span>
                            <span className="text-right">{donor.Last_Donation_Amount || "N/A"}</span>
                        </div> */}
                        {/* <div className="flex justify-between">
                            <span className="text-gray-500">Last Donation Date</span>
                            <span className="text-right">{donor.Last_Donation_Date || "N/A"}</span>
                        </div> */}
                        <div className="flex justify-between">
                            <span className="text-gray-500">Purpose</span>
                            <span className="text-right">{donor.Purpose1 || "N/A"}</span>
                        </div>
                    </div>
                </div>
            </Link>
        );
    }




    // const [totalRecords, setTotalRecords] = useState(0);





    const isMobile = useIsMobile();

    const [allContacts, setAllContacts] = useState([]);
    // const [campaignNames, setCampaignNames] = useState([]);


    const [loading, setLoading] = useState(true);


    // useEffect(() => {
    //     if (!dealerDetail?.Email) return;

    //     async function fetchContacts() {
    //         setLoading(true);

    //         if (allState["donorLeads"]) {

    //             setAllContacts(allState["donorLeads"]);

    //             const uniqueCampaigns = [
    //                 ...new Set(
    //                     allState["donorLeads"]
    //                         .map((item) => item?.Campaign_Name?.trim())
    //                         .filter((name) => !!name)
    //                 ),
    //             ];

    //             setCampaignNames(uniqueCampaigns);
    //             // console.log("SKip Fetching Leads, Compaigns")
    //             return;
    //         }

    //         try {
    //             const res = await fetch(`/server/dealer_backend/getAContact?dealerEmail=${dealerDetail.Email}`);
    //             if (!res.ok) throw new Error("Failed to fetch contacts");

    //             const data = await res.json();
    //             const contacts = data?.data || [];

    //             setAllContacts(contacts);
    //             allStatedispatch({
    //                 type: "add",
    //                 payload: { "donorLeads": contacts || [] },
    //             });


    //             const uniqueCampaigns = [
    //                 ...new Set(
    //                     contacts
    //                         .map((item) => item?.Campaign_Name?.trim())
    //                         .filter((name) => !!name)
    //                 ),
    //             ];

    //             setCampaignNames(uniqueCampaigns);
    //         } catch (err) {
    //             setError(err.message || "Unknown error");
    //         } finally {
    //             setLoading(false);
    //         }
    //     }

    //     fetchContacts();
    // }, [dealerDetail?.Email]);
    // const fetcher = (url) =>
    //     fetch(url).then((res) => {
    //         if (!res.ok) throw new Error("Failed to fetch contacts");
    //         return res.json();
    //     });
    // const dealerEmail = dealerDetail?.Email;

    // // SWR handles caching, loading & error states
    // const { data, } = useSWR(
    //     dealerEmail ? `/server/dealer_backend/getAContact?dealerEmail=${dealerEmail}` : null,
    //     fetcher,
    //     {
    //         revalidateOnFocus: false, // optional: don’t refetch when window refocuses
    //     }
    // );

    // const contacts = data?.data || [];

    // // compute unique campaign names
    // const campaignNames = [
    //     ...new Set(
    //         contacts.map((item) => item?.Campaign_Name?.trim()).filter(Boolean)
    //     ),
    // ];


    useEffect(() => {
        setRowsPerPage(searchValues.limit);
        setCurrentPage(searchValues.page);
    }, [searchValues]);










    const handleApplyFilters = () => {
        setAppliedFilters({
            selectedDisposition,
            selectedCampaignName,
            emailFilter,
            phoneFilter,
            donorNameFilter,
        });
        setSearchValues((prev) => ({ ...prev, page: 1 })); // Reset page
    };





    // ✅ Clear button handler
    const handleClearFilters = () => {
        // Keep campaign unchanged
        setSelectedCampaignName("-None-");
        setSelectedDisposition("");
        setEmailFilter("");
        setPhoneFilter("");
        setDonorNameFilter("");

        // Reset applied filters but preserve campaign
        setAppliedFilters({
            selectedCampaignName: "-None-",
            selectedDisposition: "",
            emailFilter: "",
            phoneFilter: "",
            donorNameFilter: "",
        });

        // Reset pagination
        setSearchValues({ page: 1, limit: searchValues.limit });

        // Clear only other filters from localStorage
        //localStorage.removeItem("campaign");
        localStorage.removeItem("disposition");
        localStorage.removeItem("email");
        localStorage.removeItem("phone");
        localStorage.removeItem("donor");
        localStorage.removeItem("page");

        // Do NOT remove or overwrite campaign
        // localStorage.removeItem("campaign");
    };




    const [lastOpened, setLastOpened] = useState(() => {
        const saved = localStorage.getItem("lastOpenedRecord");
        if (!saved) return null;

        const record = JSON.parse(saved);

        // Provide default values if any property is missing
        return {
            id: record.id ?? "",
            name: record.name?.trim() ?? "",
            listName: record.listName?.trim() ?? "",
            disposition: record.disposition?.trim() ?? "",
            serialNo: record.serialNo ?? "",
            lastOpenedAt: record.lastOpenedAt ?? null,
        };
    });


    const saveLastOpened = (row, serialNo) => {
        if (!row?.id) return;

        const record = {
            id: row.id,
            name: `${row.First_Name ?? ""} ${row.Last_Name ?? ""}`.trim(),
            listName: row.Campaign_Name ?? "",
            disposition: row.Call_Status ?? "",
            serialNo,
            lastOpenedAt: new Date().toISOString(),
        };

        localStorage.setItem("lastOpenedRecord", JSON.stringify(record));
        setLastOpened(record);
    };


    // useEffect(() => {
    //     if (dealerDetail?.List_Name?.length > 0) {
    //         const firstCampaign = dealerDetail.List_Name[0];
    //         console.log({ firstCampaign });
    //         // Update state
    //         setSelectedCampaignName(firstCampaign);

    //         // Save to localStorage
    //         localStorage.setItem("campaign", firstCampaign);
    //     } else {
    //         setSelectedCampaignName("");
    //         localStorage.removeItem("campaign");
    //     }
    // }, [dealerDetail]);





    // Values actually applied to API call




    // useEffect(() => {
    //     fetchContacts({
    //         page: currentPage,
    //         limit: rowsPerPage,
    //         filters: {
    //             // any filters like disposition, campaign, etc.
    //         }
    //     });
    // }, [currentPage, rowsPerPage, selectedDisposition, selectedCampaignName, debouncedEmailFilter, debouncedPhoneFilter, debouncedDonorNameFilter]);


    const OFFSET = (searchValues.page - 1) * searchValues.limit;


    return (
        <div className="p-6 space-y-6 text-gray-800 mt-[-30px]">
            {/* Toast notifications */}
            <ToastContainer position="top-right" autoClose={3000} />

            {/* Create Call Logs Modal */}
            {isWidgetModalOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[9999] px-4"
                    onClick={() => setIsWidgetModalOpen(false)}
                    aria-modal="true"
                    role="dialog"
                    aria-labelledby="create-call-logs-title"
                >
                    <div
                        className="bg-white rounded-lg p-6 sm:p-8 shadow-lg max-w-full sm:max-w-4xl max-h-[90vh] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2
                            id="create-call-logs-title"
                            className="text-xl sm:text-2xl font-bold mb-6 text-center sm:text-left"
                        >
                            Create Call Log
                        </h2>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm sm:text-base">
                            {/* Donor Name */}
                            <div>
                                <label htmlFor="donorName" className="block text-gray-700 mb-1 font-medium">
                                    Donor Name
                                </label>
                                <input
                                    id="donorName"
                                    type="text"
                                    value={`${lead?.First_Name || ""} ${lead?.Last_Name || ""}`.trim()}
                                    readOnly
                                    className="w-full bg-gray-100 border border-gray-300 rounded-md px-4 py-2 cursor-not-allowed"
                                />
                            </div>

                            {/* Email */}
                            <div>
                                <label htmlFor="email" className="block text-gray-700 mb-1 font-medium">
                                    Email
                                </label>
                                <input
                                    id="email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                                    aria-invalid={!!emailError}
                                    aria-describedby="email-error"
                                />
                                {emailError && (
                                    <p id="email-error" className="text-red-600 text-xs mt-1">
                                        {emailError}
                                    </p>
                                )}
                            </div>

                            {/* Phone */}
                            <div>
                                <label htmlFor="phone" className="block text-gray-700 mb-1 font-medium">
                                    Phone
                                </label>
                                <input
                                    id="phone"
                                    type="text"
                                    value={
                                        lead?.Mobile_No !== undefined &&
                                            lead?.Mobile_No !== null &&
                                            lead?.Mobile_No !== ""
                                            ? lead.Mobile_No
                                            : phone
                                    }
                                    onChange={(e) => setPhone(e.target.value)}
                                    readOnly={!!lead?.Mobile_No}
                                    className={`w-full border rounded-md px-4 py-2 focus:outline-none ${lead?.Mobile_No
                                        ? "bg-gray-100 cursor-not-allowed border-gray-300"
                                        : "bg-white border-gray-300 focus:ring-2 focus:ring-blue-400"
                                        } transition`}
                                />
                                {phoneError && (
                                    <p className="text-red-600 text-xs mt-1">{phoneError}</p>
                                )}
                            </div>

                            {/* Alternate Phone */}
                            <div>
                                <label htmlFor="altPhone" className="block text-gray-700 mb-1 font-medium">
                                    Alternate Phone
                                </label>
                                <input
                                    id="altPhone"
                                    type="text"
                                    value={
                                        lead?.Phone_2 !== undefined &&
                                            lead?.Phone_2 !== null &&
                                            lead?.Phone_2 !== ""
                                            ? lead.Phone_2
                                            : alternatePhone
                                    }
                                    onChange={(e) => setAlternatePhone(e.target.value)}
                                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition bg-white"
                                />
                                {/* {alternatePhoneError && (
                                    <p className="text-red-600 text-xs mt-1">{alternatePhoneError}</p>
                                )} */}
                            </div>

                            {/* Call Remarks */}
                            <div className="md:col-span-1">
                                <label className="block text-gray-700 mb-1">
                                    Call Remarks <span className="text-red-500">*</span>
                                </label>
                                <textarea
                                    rows="3"
                                    value={callRemarks}
                                    onChange={(e) => setCallRemarks(e.target.value)}
                                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                                />
                                {remarksError && (
                                    <p className="text-red-500 text-sm mt-1">{remarksError}</p>
                                )}
                            </div>

                            {/* Contact Preferences */}
                            <div>
                                <label
                                    htmlFor="contactPreference"
                                    className="block text-gray-700 mb-1 font-medium"
                                >
                                    Contact Preferences
                                </label>
                                <select
                                    id="contactPreference"
                                    value={contactPreference}
                                    onChange={(e) => setContactPreference(e.target.value)}
                                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                                    aria-invalid={!!error && !contactPreference}
                                    aria-describedby="contactPreference-error"
                                >
                                    {contactPreferencesOptions.map((option, idx) => (
                                        <option key={idx} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                                {error && !contactPreference && (
                                    <p id="contactPreference-error" className="text-red-600 text-sm mt-1">
                                        Contact Preference is required.
                                    </p>
                                )}
                            </div>

                            {/* Donation Purpose */}
                            <div>
                                <label htmlFor="donationPurpose" className="block text-gray-700 mb-1 font-medium">
                                    Donor Interest  <span className="text-red-600">*</span>
                                </label>
                                <select
                                    id="donationPurpose"
                                    value={donationPurpose}
                                    onChange={(e) => setDonationPurpose(e.target.value)}
                                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                                >
                                    <option value="">Select Interest</option>
                                    {donationOptions.map((option, idx) => (
                                        <option key={idx} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Call Dispositions */}
                            <div>
                                <label htmlFor="callStatus" className="block text-gray-700 mb-1 font-medium">
                                    Call Dispositions <span className="text-red-600">*</span>
                                </label>
                                <select
                                    id="callStatus"
                                    value={callStatus}
                                    onChange={(e) => setCallStatus(e.target.value)}
                                    className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                                    aria-invalid={!!error && !callStatus}
                                    aria-describedby="callStatus-error"
                                >
                                    {callDispositionOptions.map((option, idx) => (
                                        <option key={idx} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                                {error && !callStatus && (
                                    <p id="callStatus-error" className="text-red-600 text-sm mt-1">
                                        Call Disposition is required.
                                    </p>
                                )}
                            </div>

                            {/* Conditional Reschedule Date & Time */}
                            {callStatus === "Call back" && (
                                <div>
                                    <label
                                        htmlFor="rescheduleDateTime"
                                        className="block text-gray-700 mb-1 font-medium"
                                    >
                                        Reschedule Date & Time <span className="text-red-600">*</span>
                                    </label>
                                    <input
                                        id="rescheduleDateTime"
                                        type="datetime-local"
                                        value={rescheduleDateTime}
                                        onChange={(e) => setRescheduleDateTime(e.target.value)}
                                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                                    />
                                </div>
                            )}

                            {callStatus === "Hot lead" && (
                                <div>
                                    <label
                                        htmlFor="rescheduleDateTime"
                                        className="block text-gray-700 mb-1 font-medium"
                                    >
                                        Reschedule Date & Time <span className="text-red-600">*</span>
                                    </label>
                                    <input
                                        id="rescheduleDateTime"
                                        type="datetime-local"
                                        value={rescheduleDateTime}
                                        onChange={(e) => setRescheduleDateTime(e.target.value)}
                                        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                                    />
                                </div>
                            )}
                        </div>

                        {/* Modal buttons */}
                        <div className="flex justify-end space-x-4 mt-8">
                            <button
                                className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-md transition"
                                onClick={() => setIsWidgetModalOpen(false)}
                                type="button"
                            >
                                Cancel
                            </button>
                            <button
                                disabled={isSubmitting}
                                className="bg-green-600 disabled:bg-green-300 hover:bg-green-700 text-white px-6 py-2 rounded-md transition disabled:cursor-not-allowed"
                                onClick={async () => {
                                    const result = await handleSubmit();

                                    if (result) {
                                        // if (callStatus === "Call back") {
                                        //     await handleSubmitTask();
                                        // }
                                        setIsWidgetModalOpen(false);
                                    }
                                }}
                                type="submit"
                            >
                                {isSubmitting ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Page header & actions */}
            <div className="flex flex-wrap justify-between items-center mb-6 gap-3 ">

                {/* Birthday Button */}
                {/* Birthday Button */}
                <div className="relative">
                    <button
                        onClick={() => {
                            if (!birthdayLeads) return; // Disable interaction while loading
                            setShowBirthdayDropdown(!showBirthdayDropdown);
                        }}
                        aria-label="Upcoming birthdays"
                        className={`relative w-12 h-12 rounded-full shadow flex items-center justify-center transition ${!birthdayLeads ? 'bg-gray-200 cursor-not-allowed' : 'bg-gray-100 hover:bg-gray-200'
                            }`}
                        type="button"
                        disabled={!birthdayLeads} // Optional for keyboard nav
                    >
                        <Cake className="w-6 h-6 text-gray-600" />
                        {birthdayLeads?.length > 0 && (
                            <span className="absolute top-1 right-1 bg-red-600 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full shadow">
                                {birthdayLeads.length}
                            </span>
                        )}
                    </button>


                    {/* Birthday dropdown panel (ensure this is well positioned) */}
                    {showBirthdayDropdown && (
                        <div
                            className="absolute right-[-252px] mt-2 w-80 max-h-96 overflow-y-auto bg-white border border-gray-300 rounded-2xl shadow-xl p-5 z-50 animate-fadeIn"
                            role="dialog"
                            aria-modal="true"
                        >
                            {/* Arrow Pointer */}
                            <div className="absolute -top-2 right-6 w-4 h-4 bg-white border-l border-t border-gray-300 rotate-45"></div>

                            {/* Close Button */}
                            <button
                                onClick={() => setShowBirthdayDropdown(false)}
                                aria-label="Close upcoming birthdays"
                                className="absolute top-3 right-3 rounded-full p-1 hover:bg-[#E6F0FA] focus:outline-none focus:ring-2 focus:ring-[#2070B9] transition"
                                style={{ color: "#2070B9" }}
                            >
                                <X className="w-5 h-5" />
                            </button>

                            {/* Title */}
                            <h3
                                className="text-lg font-semibold mb-4 border-b border-gray-200 pb-2 select-none"
                                style={{ color: "#2070B9" }}
                            >
                                🎉 Upcoming Birthdays
                            </h3>

                            {/* Content */}
                            {birthdayLeads.length === 0 ? (
                                <div className="flex flex-col items-center justify-center h-32">
                                    <span className="text-3xl mb-2" style={{ color: "#2070B9" }}>
                                        🎉
                                    </span>
                                    <p className="text-sm text-gray-500 text-center select-none">
                                        No upcoming birthdays.
                                    </p>
                                </div>
                            ) : (
                                <ul className="space-y-3">
                                    {birthdayLeads.map((lead) => (
                                        <li
                                            key={lead.id}
                                            onClick={() => {
                                                markBirthdayAsSeen(lead.id);
                                                setShowBirthdayDropdown(false);
                                                navigate(`/contact-details/${lead.id}`);
                                            }}
                                            className="cursor-pointer rounded-xl border border-gray-200 p-4 hover:bg-[#E6F0FA] focus:outline-none focus:ring-2 focus:ring-[#2070B9] transition select-none"
                                            tabIndex={0}
                                            role="button"
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" || e.key === " ") {
                                                    markBirthdayAsSeen(lead.id);
                                                    setShowBirthdayDropdown(false);
                                                    navigate(`/contact-details/${lead.id}`);
                                                }
                                            }}
                                        >
                                            <div className="flex justify-between items-center min-w-0">
                                                <div className="min-w-0">
                                                    <p className="font-medium text-gray-900 truncate">
                                                        {lead.First_Name} {lead.Last_Name}
                                                    </p>
                                                    <p className="text-xs text-gray-500 mt-0.5 select-text">
                                                        📅 {new Date(lead.Date_of_Birth).toLocaleDateString()}
                                                    </p>
                                                </div>
                                                <span
                                                    className="text-xs font-semibold whitespace-nowrap ml-2 flex-shrink-0"
                                                    style={{ color: "#2070B9" }}
                                                >
                                                    {lead.daysUntilBirthday === 0 ? "Today" : "Tomorrow"}
                                                </span>
                                            </div>

                                            <div className="mt-2 text-xs text-gray-600 space-y-0.5 select-text">
                                                <p>📧 {lead.Email}</p>
                                                <p>📞 {lead.Mobile}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}


                </div>

                {/* Filters */}
                {/* // Keep your existing fetchContacts function as it is */}

                <div className=" rounded-md px-4 py-3  flex flex-wrap items-end gap-4">

                    {/* Call Dispositions */}
                    <div className="flex flex-col">
                        <label htmlFor="callDisposition" className="text-gray-800 text-sm font-medium mb-1">
                            Call Dispositions
                        </label>
                        <select
                            id="callDisposition"
                            value={selectedDisposition}
                            onChange={(e) => {
                                setSelectedDisposition(e.target.value);
                                setCurrentPage(1);
                            }}
                            className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-400 transition bg-white w-48"
                        >
                            <option value="">All</option>
                            {callDispositionOptions?.map((option, idx) => (
                                <option key={idx} value={option}>{option}</option>
                            ))}
                        </select>
                    </div>

                    {/* List Name */}
                    <div className="flex flex-col">
                        <label
                            htmlFor="listName"
                            className="text-gray-800 text-sm font-medium mb-1"
                        >
                            List Name
                        </label>

                        <select
                            id="listName"
                            value={selectedCampaignName}
                            onChange={(e) => {
                                setSelectedCampaignName(e.target.value);
                                setCurrentPage(1);
                            }}
                            className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-400 transition bg-white w-48"
                        >
                            <option value="-None-">-None-</option>

                            {dealerDetail?.List_Name?.length > 0 &&
                                dealerDetail.List_Name.map((name) => (
                                    <option key={name} value={name}>
                                        {name}
                                    </option>
                                ))}
                        </select>
                    </div>


                    {/* Email */}
                    <div className="flex flex-col relative">
                        <label htmlFor="emailFilter" className="text-gray-800 text-sm font-medium mb-1">
                            Email
                        </label>
                        <input
                            id="emailFilter"
                            type="text"
                            value={emailFilter}
                            placeholder="Enter email"
                            onChange={(e) => {
                                setEmailFilter(e.target.value);
                                setCurrentPage(1);
                            }}
                            className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-400 transition bg-white w-56 pr-7"
                        />
                        {emailFilter && (
                            <button
                                type="button"
                                onClick={() => {
                                    setEmailFilter("");
                                    setCurrentPage(1);
                                }}
                                className="absolute right-2 top-[34px] text-gray-400 hover:text-gray-600 text-base focus:outline-none"
                                aria-label="Clear email filter"
                            >
                                ✕
                            </button>
                        )}
                    </div>

                    {/* Phone */}
                    <div className="flex flex-col relative">
                        <label htmlFor="phoneFilter" className="text-gray-800 text-sm font-medium mb-1">
                            Phone
                        </label>
                        <input
                            id="phoneFilter"
                            type="text"
                            value={phoneFilter}
                            placeholder="Enter phone"
                            onChange={(e) => {
                                setPhoneFilter(e.target.value);
                                setCurrentPage(1);
                            }}
                            className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-400 transition bg-white w-48 pr-7"
                        />
                        {phoneFilter && (
                            <button
                                type="button"
                                onClick={() => {
                                    setPhoneFilter("");
                                    setCurrentPage(1);
                                }}
                                className="absolute right-2 top-[34px] text-gray-400 hover:text-gray-600 text-base focus:outline-none"
                                aria-label="Clear phone filter"
                            >
                                ✕
                            </button>
                        )}
                    </div>

                    {/* Donor Name */}
                    <div className="flex flex-col relative">
                        <label htmlFor="donorNameFilter" className="text-gray-800 text-sm font-medium mb-1">
                            Donor Name
                        </label>
                        <input
                            id="donorNameFilter"
                            type="text"
                            value={donorNameFilter}
                            placeholder="Enter donor name"
                            onChange={(e) => {
                                setDonorNameFilter(e.target.value);
                                setCurrentPage(1);
                            }}
                            className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:ring-2 focus:ring-blue-400 transition bg-white w-48 pr-7"
                        />
                        {donorNameFilter && (
                            <button
                                type="button"
                                onClick={() => {
                                    setDonorNameFilter("");
                                    setCurrentPage(1);
                                }}
                                className="absolute right-2 top-[34px] text-gray-400 hover:text-gray-600 text-base focus:outline-none"
                                aria-label="Clear donor name filter"
                            >
                                ✕
                            </button>
                        )}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-4 ml-auto mt-6 sm:mt-0">

                        <button
                            type="button"
                            onClick={handleClearFilters}
                            className="bg-[#F3F4F6] hover:bg-[#C0DCF3] text-gray-700 font-medium px-4 py-1.5 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-[#C0DCF3] focus:ring-offset-1 border border-[#003967] transition"
                        >
                            Clear Filters
                        </button>



                        <button
                            type="button"
                            onClick={handleApplyFilters}
                            className="bg-[#F3F4F6] hover:bg-[#C0DCF3] text-gray-700 font-medium px-4 py-1.5 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-[#C0DCF3] focus:ring-offset-1 border border-[#003967] transition"
                        >
                            Apply Filters
                        </button>

                    </div>

                </div>



                {lastOpened && dealerDetail?.List_Name && (
                    <div
                        className="
      mb-4 p-3 rounded-lg 
      text-[#2070B9] font-medium cursor-pointer
      bg-white shadow-lg border-l-4 border-[#2070B9] 
      hover:bg-[#eaf2fc] hover:text-gray-700
      transition-colors duration-200
    "
                        onClick={() => window.open(`/app/contact-details/${lastOpened.id}`, "_blank")}
                    >
                        Last worked on:{" "}
                        <strong>
                            S.No. - {lastOpened.serialNo || ""} | Date:{" "}
                            {lastOpened.serialNo && lastOpened.lastOpenedAt
                                ? new Date(lastOpened.lastOpenedAt).toLocaleString()
                                : ""}
                            | Donor Name: {lastOpened.name} | List Name: {lastOpened.listName} | Call Disposition: {lastOpened.disposition}
                        </strong>
                    </div>
                )}










            </div>

            {/* Data / Loading / Empty States */}
            {isLoading ? (
                <div className="flex justify-center items-center gap-3 py-10 text-blue-600">
                    <svg
                        className="animate-spin h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        />
                    </svg>
                    <span>Loading Data...</span>
                </div>
            ) : leads.length === 0 ? (
                <p className="text-center text-blue-600 font-medium py-10">No donors available</p>
            ) : isMobile ? (
                <div className="px-4 space-y-4">
                    {leads.map((donor, index) => (
                        <MobileDonorCard
                            key={index}
                            serialNo={(currentPage - 1) * rowsPerPage + index + 1}
                            donor={donor}
                            setLead={setLead}
                            setPhone={setPhone}
                            setEmail={setEmail}
                            setAlternatePhone={setAlternatePhone}
                            setCallRemarks={setCallRemarks}
                            setDonationPurpose={setDonationPurpose}
                            setCallStatus={setCallStatus}
                            setIsWidgetModalOpen={setIsWidgetModalOpen}
                        />
                    ))}
                </div>
            ) : (
                <>
                    <DataTable
                        columns={columns}
                        data={leads}
                        fixedHeader
                        dense
                        responsive
                        highlightOnHover
                        progressPending={isLoading}
                        className="custom-table text-base"
                        onRowClicked={(row, e) => {
                            // Prevent double-trigger if name cell was clicked
                            if (e.target.closest(".name-cell")) return;

                            const index = leads.findIndex(item => item.id === row.id);
                            const serialNo = (currentPage - 1) * rowsPerPage + index + 1;

                            saveLastOpened(row, serialNo);
                            window.open(`/app/contact-details/${row.id}`, "_blank");
                        }}

                        customStyles={{
                            headCells: { style: { fontSize: "16px", fontWeight: "700", background: "#F3F7FA", color: "#1e3a8a" } },
                            cells: { style: { whiteSpace: "nowrap", overflow: "visible", fontSize: "15px" } },
                            rows: {
                                style: {
                                    transition: "background 0.2s",
                                    "&:hover": { background: "#ebf4ff" },
                                },
                            },
                        }}
                    />

                    <div className="mt-4 flex flex-wrap justify-between items-center gap-4 px-2">
                        <div className="flex items-center text-gray-700 text-sm md:text-base">
                            <span className="font-medium mr-1">Showing</span>
                            <span className="px-2 py-1 bg-blue-100 text-blue-700 font-semibold rounded-lg">
                                {`${(currentPage - 1) * rowsPerPage + 1}–${Math.min(
                                    currentPage * rowsPerPage,
                                    totalRecords
                                )}`}
                            </span>
                            <span className="ml-1">of {totalRecords} entries</span>
                        </div>

                        <div className="flex items-center gap-2">
                            <label htmlFor="recordsPerPage" className="text-gray-700 font-medium select-none">
                                Records per page:
                            </label>
                            <select
                                id="recordsPerPage"
                                value={searchValues.limit}
                                onChange={(e) =>
                                    setSearchValues((prev) => ({
                                        ...prev,
                                        limit: Number(e.target.value),
                                    }))
                                }

                                className="border border-gray-300 rounded px-2 py-1 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                            >
                                {[25, 50, 100, 200].map((n) => (
                                    <option key={n} value={n}>
                                        {n}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(totalRecords / rowsPerPage)}
                            onPageChange={onPageChange}
                        />
                    </div>
                </>
            )}
        </div>
    );

}
